import { useCallback, useState } from "react";
import Sidebar from "./layout/Sidebar";
import Login from "./pages/Login";
import Conversations from "./pages/Conversations";
import AnalysisDashboard from "./pages/AnalysisDashboard";
import WaitingResponse from "./pages/WaitingResponse";
import ActiveService from "./pages/ActiveService";
import Automations from "./pages/Automations";
import Scripts from "./pages/Scripts";
import Contacts from "./pages/Contacts";
import Tags from "./pages/Tags";
import Funnel from "./pages/Funnel";
import Attachment from "./pages/Attachment";
import QuickMessages from "./pages/QuickMessages";
import Users from "./pages/Users";
import Settings from "./pages/Settings";
import WhatsAppConnectionInterface from "./pages/WhatsAppConnectionInterface";
import { useAuth } from "./context/AuthContext";
import { WebSocketProvider } from "./context/WebSocketContext";
import CriticalAnalysisAlerts from "./components/analysis/CriticalAnalysisAlerts";

import { Loader } from "lucide-react";

const App = () => {
  const [activeView, setActiveView] = useState("conversations");
  // Conversa que outra tela pediu para abrir (ex.: fila de prioridade da análise).
  const [focusedConversationId, setFocusedConversationId] = useState(null);
  const { user, loading } = useAuth();

  const openConversation = useCallback((conversationId) => {
    setFocusedConversationId(conversationId);
    setActiveView("conversations");
  }, []);

  const clearFocusedConversation = useCallback(
    () => setFocusedConversationId(null),
    [],
  );

  if (loading) {
    return (
      <div className="flex h-screen items-center justify-center bg-gray-900">
        <div className="flex flex-col items-center">
          <Loader className="mb-4 animate-spin text-4xl text-green-500" />
          <p className="text-lg text-gray-600">Carregando...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Login />;
  }

  const renderContent = () => {
    switch (activeView) {
      case "conversations":
        return (
          <Conversations
            focusConversationId={focusedConversationId}
            onFocusHandled={clearFocusedConversation}
          />
        );
      case "analysis":
        return <AnalysisDashboard onOpenConversation={openConversation} />;
      case "waiting":
        return <WaitingResponse onOpenConversation={openConversation} />;
      case "active":
        return <ActiveService onOpenConversation={openConversation} />;
      case "automations":
        return <Automations />;
      case "scripts":
        return <Scripts />;
      case "contacts":
        return <Contacts />;
      case "quickMessages":
        return <QuickMessages />;
      case "tags":
        return <Tags />;
      case "funnel":
        return <Funnel onOpenConversation={openConversation} />;
      case "attachment":
        return <Attachment />;
      case "users":
        return <Users />;
      case "settings":
        return <Settings />;
      case "WhatsAppConnectionInterface":
        return <WhatsAppConnectionInterface />;
      default:
        return <Conversations />;
    }
  };

  return (
    <WebSocketProvider>
      <CriticalAnalysisAlerts onOpenConversation={openConversation} />
      <div className="flex h-screen bg-gray-100">
        <Sidebar activeView={activeView} setActiveView={setActiveView} />
        {renderContent()}
      </div>
    </WebSocketProvider>
  );
};

export default App;
